<template>
  <el-row type="flex" justify="center">
    <el-col :span="8">
      <div class="grid-content bg-purple-light">
        <el-card v-loading="loading" class="box-card">
          <div slot="header" class="clearfix">
            Order Reconciliation Report
          </div>
          <el-form label-position="left" :model="form" :rules="rules" ref="form">
            <el-form-item label="Payment Gateway" prop="gateway">
              <el-select v-model="form.gateway" placeholder="Select Payment Gateway" style="width: 250px" @change="onGatewayChange">
                <el-option
                    v-for="item in gatewayOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Store" prop="region">
              <el-select v-model="form.region" placeholder="Select Store" style="width: 200px" @change="onRegionChange">
                <el-option
                    v-for="item in regionOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Start Datetime" prop="start">
              <el-date-picker
                  v-model="form.start"
                  type="datetime"
                  placeholder="Select date and time">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="End Datetime" prop="end">
              <el-date-picker
                  v-model="form.end"
                  type="datetime"
                  placeholder="Select date and time">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="Combine Orders" prop="combineOrders">
              <el-switch
                  :active-value="1"
                  :inactive-value="0"
                  :disabled="form.gateway === 'paypal'"
                  v-model="form.combine_orders">
              </el-switch>
            </el-form-item>
            <el-form-item>
              <el-button :loading="loading" type="primary" @click="submitForm('form')">Generate</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import {notify} from "../../utils";
import axios from "../../repositories";

const defaultRegionOptions = [
    {
      value: 'ca',
      label: 'CA'
    }, {
      value: 'usa',
      label: 'USA'
    }, {
      value: 'mx',
      label: 'MX'
    }];

const defaultGatewayOptions = [
    {
      value: 'shopify',
      label: 'Shopify'
    }, {
      value: 'paypal',
      label: 'Paypal'
    }, {
      value: 'afterpay',
      label: 'Afterpay'
    }, {
      value: 'amazon',
      label: 'Amazon'
  }, {
      value: 'amazon_pay',
      label: 'Amazon Pay'
  }];

export default {
  name: "OrderReconciliationReportGenerator",
  data() {
    return {
      form: {
        gateway: '',
        region: '',
        start: '',
        end: '',
        combine_orders: 1
      },
      rules: {
        gateway: { required: true, message: 'Required', trigger: 'change' },
        region: { required: true, message: 'Required', trigger: 'change' },
        start: { required: true, message: 'Required', trigger: 'blur' },
        end: { required: true, message: 'Required', trigger: 'blur' },
      },
      gatewayOptions: defaultGatewayOptions,
      regionOptions: defaultRegionOptions,
      loading: false,
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          try {
            this.loading = true;
            axios.get('/finance/reports/order-reconciliation', {
              params: this.form,
            }).then((response) => {
              notify(response.data.message, 'success');
            }).catch((err) => {
              notify(err.message, 'danger');
            }).finally(() => {
              this.loading = false;
            });
          } catch (err) {
            if(err.response.data.errors) {
              notify(err.response.data.errors, 'danger');
            }
          }
        } else {
          notify('Please fill out the form.', 'danger');
        }
      });
    },
    onGatewayChange(value) {
      if(value === 'paypal' || value === 'afterpay') {
        this.regionOptions = _.filter(defaultRegionOptions, (o) => o.value === 'ca' || o.value === 'usa');
      } else if(value === 'amazon_pay') {
        this.regionOptions = _.filter(defaultRegionOptions, (o) => o.value === 'usa');
      } else if(value === 'amazon') {
        this.regionOptions = defaultRegionOptions;
      } else {
        this.regionOptions = _.filter(defaultRegionOptions, (o) => o.value !== 'mx');
      }
      if(value === 'paypal' || value === 'amazon') {
        this.form.combine_orders = 0;
      }
      if(!_.find(this.regionOptions, (o) => this.form.region === o.value)) {
        this.form.region = '';
      }
    },
    onRegionChange(value) {
      if(value === 'mx') {
        this.gatewayOptions = _.filter(defaultGatewayOptions, (o) => o.value === 'amazon');
      } else if(value === 'ca') {
        this.gatewayOptions = _.filter(defaultGatewayOptions, (o) => o.value !== 'amazon_pay');
      } else {
        this.gatewayOptions = defaultGatewayOptions;
      }
      if(!_.find(this.gatewayOptions, (o) => this.form.gateway === o.value)) {
        this.form.gateway = '';
      }
    }
  },
}
</script>

<style scoped>

</style>
